(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-addresses"] && !Shopify.designMode) return;
  try {
    
  const toggleBtn = document.querySelector('[data-address-toggle]');
  const cancelBtn = document.querySelector('[data-address-cancel]');
  const formWrapper = document.querySelector('[data-address-form]');

  if (toggleBtn && formWrapper) {
    toggleBtn.addEventListener('click', () => {
      formWrapper.style.display = formWrapper.style.display === 'none' ? 'block' : 'none';
    });
  }

  if (cancelBtn && formWrapper) {
    cancelBtn.addEventListener('click', () => {
      formWrapper.style.display = 'none';
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"] && !Shopify.designMode) return;
  try {
    
  // Copy URL functionality
  document.querySelectorAll('[data-copy-url]').forEach(btn => {
    btn.addEventListener('click', async () => {
      const url = btn.dataset.copyUrl;
      try {
        await navigator.clipboard.writeText(url);
        btn.classList.add('is-copied');
        setTimeout(() => btn.classList.remove('is-copied'), 2000);
      } catch (err) {
        console.error('Failed to copy URL:', err);
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog"] && !Shopify.designMode) return;
  try {
    
  const blogGrid = document.querySelector('[data-blog-grid]');
  const storageKey = 'blog-view-preference';

  // Get all view toggle buttons (desktop and drawer)
  const allViewBtns = document.querySelectorAll('[data-view]');

  // Restore saved preference
  const savedView = localStorage.getItem(storageKey);
  if (savedView === 'list' && blogGrid) {
    blogGrid.classList.add('is-list-view');
    allViewBtns.forEach(btn => {
      const isActive = btn.dataset.view === 'list';
      btn.classList.toggle('is-active', isActive);
      btn.setAttribute('aria-pressed', isActive);
    });
  }

  // Handle view toggle clicks (for both desktop and drawer toggles)
  allViewBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      const view = btn.dataset.view;

      // Update all button states (keep desktop and drawer in sync)
      allViewBtns.forEach(b => {
        const isActive = b.dataset.view === view;
        b.classList.toggle('is-active', isActive);
        b.setAttribute('aria-pressed', isActive);
      });

      // Update grid view
      if (blogGrid) {
        if (view === 'list') {
          blogGrid.classList.add('is-list-view');
        } else {
          blogGrid.classList.remove('is-list-view');
        }
      }

      // Save preference
      localStorage.setItem(storageKey, view);
    });
  });

  // Mobile Filter Drawer
  const filterToggle = document.querySelector('[data-filter-toggle]');
  const filterDrawer = document.querySelector('[data-filter-drawer]');
  const filterClose = document.querySelector('[data-filter-close]');
  const filterOverlay = document.querySelector('[data-filter-overlay]');

  const openDrawer = () => {
    filterDrawer?.classList.add('is-open');
    filterOverlay?.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  };

  const closeDrawer = () => {
    filterDrawer?.classList.remove('is-open');
    filterOverlay?.classList.remove('is-open');
    document.body.style.overflow = '';
  };

  filterToggle?.addEventListener('click', openDrawer);
  filterClose?.addEventListener('click', closeDrawer);
  filterOverlay?.addEventListener('click', closeDrawer);

  } catch(e) { console.error(e); }
})();
})();
